<div class="ui-modal-overlay" [ngStyle]="overlayStyles"></div>
<div class="ui-modal shadow border-round" tabindex="-1" role="dialog" #modalRoot appResizable [south]="true"
  style="overflow-y: hidden; overflow-x: hidden;" [east]="true" [southEast]="true" [minWidth]="minWidth"
  [minHeight]="minHeight" (resizing)="onResize($event)" appDraggable [dragEventTarget]="dragEventTarget"
  [ngStyle]="dialogStyles" (mousedown)="moveOnTop()" (touchstart)="moveOnTop()">
  <div class="modal-header  pr-1" #modalHeader (mousedown)="initDrag($event)" (touchstart)="initDrag($event)">
    <div class="ui-titlebar">
      <span class="ui-modal-title truncate-text" *ngIf="modalTitle">{{modalTitle}}</span>
      <ng-content select=".app-modal-header"></ng-content>
    </div>
    <div class="ui-controlbar">
      <span *ngIf="minimizable" (click)="toggleMinimize($event)">
        <i class="mio vam mr-1 pointer minimize_button">minimize</i>
      </span>
      <span *ngIf="maximizable" (click)="toggleMaximize($event)">
        <i class="mio vam mr-1 pointer unmaximize_button" *ngIf="maximized">zoom_out_map</i>
        <i class="mio vam mr-1 pointer maximize_button" *ngIf="!maximized">zoom_out_map</i>
      </span>
      <span (click)="hide()" (mousedown)="onCloseIcon($event)" (touchstart)="onCloseIcon($event)">
        <i class="mio vam pointer">close</i>
      </span>
    </div>
  </div>
  <div class="modal-body" #modalBody>
    <ng-content select=".app-modal-body"></ng-content>
  </div>
  <div class="modal-footer" #modalFooter>
    <ng-content select=".app-modal-footer"></ng-content>
  </div>
</div>